// ===============================
// SNKR – Wishlist + Share + Wishlist Page (FIXED)
// ===============================

var WISHLIST_KEY = 'snkr_wishlist_products';

// --- helpers de localStorage ---
function getWishlist() {
  try {
    var data = localStorage.getItem(WISHLIST_KEY);
    if (!data) return [];
    return JSON.parse(data);
  } catch (e) {
    console.warn('Could not read wishlist from localStorage', e);
    return [];
  }
}

function saveWishlist(list) {
  try {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
  } catch (e) {
    console.warn('Could not save wishlist to localStorage', e);
  }
}

function isInWishlist(handle) {
  var list = getWishlist();
  return list.indexOf(handle) !== -1;
}

function addToWishlist(handle) {
  var list = getWishlist();
  if (list.indexOf(handle) === -1) {
    list.push(handle);
    saveWishlist(list);
  }
}

function removeFromWishlist(handle) {
  var list = getWishlist();
  var index = list.indexOf(handle);
  if (index !== -1) {
    list.splice(index, 1);
    saveWishlist(list);
  }
}

// --- estado visual (USAMOS .is-active) ---
function updateWishlistButtonState(button, active) {
  if (!button) return;
  if (active) {
    button.classList.add('is-active');        // 👈 AQUÍ LA CLAVE
    button.setAttribute('aria-pressed', 'true');
  } else {
    button.classList.remove('is-active');
    button.setAttribute('aria-pressed', 'false');
  }
}

function initWishlistButtons() {
  var buttons = document.querySelectorAll('[data-wishlist-button]');
  if (!buttons.length) return;

  var list = getWishlist();

  buttons.forEach(function (button) {
    var handle = button.getAttribute('data-product-handle');
    if (!handle) return;

    var active = list.indexOf(handle) !== -1;
    updateWishlistButtonState(button, active);
  });
}

// --- página de favoritos ---
function initWishlistPage() {
  var pageEl = document.querySelector('[data-wishlist-page]');
  if (!pageEl) return;

  var grid = document.getElementById('WishlistPageGrid');
  var empty = document.getElementById('WishlistPageEmpty');

  if (!grid || !empty) return;

  var handles = getWishlist();

  if (!handles.length) {
    empty.style.display = 'block';
    grid.style.display = 'none';
    return;
  }

  empty.style.display = 'none';
  grid.style.display = 'grid';

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      var moneyFormat =
        (window.theme && window.theme.moneyFormat) || '{{amount}}';
      return Shopify.formatMoney(cents, moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  handles.forEach(function (handle) {
    fetch('/products/' + handle + '.js')
      .then(function (response) {
        if (!response.ok) throw new Error('Network error');
        return response.json();
      })
      .then(function (product) {
        var firstImage =
          product.images && product.images.length ? product.images[0] : null;

        var item = document.createElement('article');
        item.className = 'WishlistPage__Item';
        item.setAttribute('data-wishlist-item', handle);

        item.innerHTML =
          '<a href="' + product.url + '" class="WishlistPage__ImageWrapper">' +
          (firstImage
            ? '<img src="' +
              firstImage +
              '" alt="' +
              product.title.replace(/"/g, '&quot;') +
              '" class="WishlistPage__Image">'
            : '') +
          '</a>' +
          '<div class="WishlistPage__Info">' +
          '<a href="' +
          product.url +
          '" class="WishlistPage__Title">' +
          product.title +
          '</a>' +
          '<div class="WishlistPage__Price">' +
          formatMoney(product.price) +
          '</div>' +
          '<button type="button" class="WishlistPage__Remove" data-wishlist-remove="' +
          handle +
          '">Remove</button>' +
          '</div>';

        grid.appendChild(item);
      })
      .catch(function (error) {
        console.warn('Error loading product for wishlist', handle, error);
      });
  });
}

// --- delegación de clicks ---
document.addEventListener('click', function (event) {
  // 1) botón favoritos
  var wishlistButton = event.target.closest('[data-wishlist-button]');
  if (wishlistButton) {
    var handle = wishlistButton.getAttribute('data-product-handle');
    if (!handle) return;

    var active = isInWishlist(handle);

    if (active) {
      removeFromWishlist(handle);
      updateWishlistButtonState(wishlistButton, false);
    } else {
      addToWishlist(handle);
      updateWishlistButtonState(wishlistButton, true);
    }

    event.preventDefault();
    return;
  }

  // 2) botón compartir (link del producto)
  var shareButton = event.target.closest('[data-share-button]');
  if (shareButton) {
    var shareUrl =
      shareButton.getAttribute('data-share-url') || window.location.href;
    var shareTitle = document.title || 'Check this product';

    if (navigator.share) {
      navigator
        .share({
          title: shareTitle,
          url: shareUrl
        })
        .catch(function (error) {
          console.warn('Share canceled or failed:', error);
        });
    } else {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(shareUrl)
          .then(function () {
            shareButton.classList.add('WishlistShare__Button--copied');
            setTimeout(function () {
              shareButton.classList.remove('WishlistShare__Button--copied');
            }, 2000);
          })
          .catch(function () {
            alert('Copy this link: ' + shareUrl);
          });
      } else {
        alert('Copy this link: ' + shareUrl);
      }
    }

    event.preventDefault();
    return;
  }

  // 3) botón Remove en la página de favoritos
  var removeButton = event.target.closest('[data-wishlist-remove]');
  if (removeButton) {
    var removeHandle = removeButton.getAttribute('data-wishlist-remove');
    if (!removeHandle) return;

    removeFromWishlist(removeHandle);

    var item = document.querySelector(
      '[data-wishlist-item="' + removeHandle + '"]'
    );
    if (item && item.parentNode) {
      item.parentNode.removeChild(item);
    }

    var grid = document.getElementById('WishlistPageGrid');
    var empty = document.getElementById('WishlistPageEmpty');
    if (grid && empty && !grid.querySelector('[data-wishlist-item]')) {
      grid.style.display = 'none';
      empty.style.display = 'block';
    }

    var buttons = document.querySelectorAll(
      '[data-wishlist-button][data-product-handle="' + removeHandle + '"]'
    );
    buttons.forEach(function (btn) {
      updateWishlistButtonState(btn, false);
    });

    event.preventDefault();
    return;
  }
});

// --- init ---
document.addEventListener('DOMContentLoaded', function () {
  initWishlistButtons();
  initWishlistPage();
});
